<template>
  <div class="student-dash">
    <!-- Hero header -->
    <div class="student-hero">
      <div class="student-hero-circles">
        <div class="hero-circle hero-circle-1"></div>
        <div class="hero-circle hero-circle-2"></div>
      </div>
      <div class="student-hero-content">
        <div>
          <p class="hero-sub" style="color:rgba(255,255,255,0.9)">{{ $t('pages.dashboard') }}</p>
          <h1 class="hero-title" style="color:#fff">{{ $t('pages.welcome') }}</h1>
        </div>
        <div class="hero-bus-icon">
          <v-icon color="white" size="36">mdi-school-outline</v-icon>
        </div>
      </div>
    </div>

    <!-- Gjendja e etiketes Bluetooth. Vetem po ose jo: kodi i etiketes nuk
         i tregohet kurre nxenesit, sepse me te do te mund t'i jepej nje
         etikete e dyte dikujt tjeter. -->
    <div v-if="etiketa !== null" class="etiketa-rresht mt-4" :class="etiketa ? 'eshte' : 'snuk'">
      <v-icon :color="etiketa ? '#2E7D32' : '#90A4AE'" size="22">
        {{ etiketa ? 'mdi-bluetooth-connect' : 'mdi-bluetooth-off' }}
      </v-icon>
      <div class="etiketa-tekst">
        <div class="etiketa-titull">
          {{ etiketa ? $t('tags.status_active') : $t('tags.status_inactive') }}
        </div>
        <div class="etiketa-ndihme">
          {{ etiketa ? $t('tags.status_help_active') : $t('tags.status_help_inactive') }}
        </div>
      </div>
    </div>

    <!-- Quick action cards -->
    <v-row class="mt-4">
      <v-col cols="6" sm="4">
        <v-card class="quick-card quick-card--orange" elevation="0" @click="$router.push({ name: 'student-live-tracking' })">
          <div class="quick-icon-wrap">
            <v-icon color="white" size="28">mdi-crosshairs-gps</v-icon>
          </div>
          <p class="quick-label">{{ $t('sidebar.live_tracking') }}</p>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4">
        <v-card class="quick-card quick-card--green" elevation="0" @click="$router.push({ name: 'student-payments' })">
          <div class="quick-icon-wrap">
            <v-icon color="white" size="28">mdi-credit-card-multiple-outline</v-icon>
          </div>
          <p class="quick-label">{{ $t('sidebar.payments') }}</p>
        </v-card>
      </v-col>
      <v-col cols="6" sm="4">
        <v-card class="quick-card quick-card--purple" elevation="0" @click="$router.push({ name: 'student-notifications' })">
          <div class="quick-icon-wrap">
            <v-icon color="white" size="28">mdi-bell-outline</v-icon>
          </div>
          <p class="quick-label">{{ $t('sidebar.notifications') }}</p>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import auth from '@/services/AuthService';

export default {
  data() {
    return {
      mode: null,
      isLoading: false,
      // null = ende nuk dihet; rreshti nuk shfaqet derisa te vije pergjigjja,
      // qe te mos pulsoje "nuk keni etikete" per nje çast.
      etiketa: null,
    };
  },
  mounted() {
    this.mode = auth.getMode();
    this.merrEtiketen();
  },
  methods: {
    async merrEtiketen() {
      try {
        const { data } = await axios.get('/student-tags/status');
        // Kur moduli nuk eshte i ndezur per shkollen, rreshti nuk shfaqet
        // fare: nxenesi nuk ka pse te mesoje per nje veçori qe nuk e ka.
        this.etiketa = data.enabled === false ? null : !!data.active;
      } catch (e) {
        // Pa pergjigje, rreshti thjesht nuk shfaqet: eshte informacion
        // dytesor dhe nuk ia vlen nje njoftim gabimi te paneli.
        this.etiketa = null;
      }
    },
  },
};
</script>

<style scoped>
.student-dash {
  padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
}
.etiketa-rresht {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e0e6eb;
  background: #fff;
}
.etiketa-rresht.eshte {
  border-color: #c8e6c9;
  background: #f4fbf4;
}
.etiketa-titull {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}
.etiketa-ndihme {
  font-size: 12px;
  color: #78909c;
}
.student-hero {
  background: linear-gradient(135deg, #e65100 0%, #f57c00 50%, #ff8f00 100%);
  border-radius: 16px;
  padding: 24px 20px;
  position: relative;
  overflow: hidden;
}
.student-hero-circles {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.hero-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255,255,255,0.08);
}
.hero-circle-1 { width: 160px; height: 160px; top: -40px; right: -40px; }
.hero-circle-2 { width: 100px; height: 100px; bottom: -30px; left: -20px; }
.student-hero-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hero-sub {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  font-weight: 600;
}
.hero-title {
  font-size: 26px;
  font-weight: 800;
}
.hero-bus-icon {
  width: 64px; height: 64px;
  background: rgba(255,255,255,0.15);
  border-radius: 16px;
  display: flex; align-items: center; justify-content: center;
}
.quick-card {
  border-radius: 14px !important;
  border: none !important;
  padding: 20px 16px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;
  overflow: hidden;
  position: relative;
}
.quick-card::before {
  content: '';
  position: absolute;
  top: -20px; right: -20px;
  width: 70px; height: 70px;
  border-radius: 50%;
  background: rgba(255,255,255,0.1);
  pointer-events: none;
}
.quick-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.18) !important;
}
.quick-card--orange { background: linear-gradient(135deg, #BF360C 0%, #e65100 60%, #FF8F00 100%); }
.quick-card--green  { background: linear-gradient(135deg, #1B5E20 0%, #2E7D32 60%, #66BB6A 100%); }
.quick-card--purple { background: linear-gradient(135deg, #4A148C 0%, #6A1B9A 60%, #AB47BC 100%); }
.quick-icon-wrap {
  width: 52px; height: 52px;
  border-radius: 14px;
  background: rgba(255,255,255,0.2);
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 12px;
}
.quick-label {
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
</style>
